/**
 * Activates the central fetch dispatcher after all handlers are registered (loads after entryPoints.js).
 */
luxInstallFetchDispatcher()
